// import React from "react";
// import GenericTable from "../GenericTable/GenericTable";
// import billingInfo from "../../../data/billing_history_success.json"; // Assuming you have a JSON file with user data
// const billingColumns = [
//     { id: "client_name", label: "Client Name"},
//     { id: "store_name", label: "Store Name" },
//     { id: "invoice_number", label: "Invoice Number" },
//     { id: "billing_date", label: "Billing Date" },
//     { id: "payment_status", label: "Payment Status" },
//     { id: "subscription", label: "Subscription" },
//     { id: "brand", label: "Brand" },
//     {
//   id: "total_amount",
//   label: "Total Amount",
//   render: (row) => `$ ${Number(row.total_amount).toLocaleString()}`
// },
//     { id: "due_date", label: "Due Date" },
// ];
// const downloadInvoice = (row) => {
//   // For now, create a placeholder PDF Blob
//   const pdfContent = `
//     Invoice
//     ---------------------
//     Store: ${row.store_name}
//     Invoice #: ${row.invoice_number}
//     Billing Date: ${row.billing_date}
//     Subscription: ${row.subscription}
//     Total Amount: ${row.total_amount}
//     Payment Status: ${row.payment_status}
//     Due Date: ${row.due_date}
//   `;

//   const blob = new Blob([pdfContent], { type: "application/pdf" });
//   const url = URL.createObjectURL(blob);

//   const link = document.createElement("a");
//   link.href = url;
//   link.download = `Invoice_${row.invoice_number}.pdf`;
//   link.click();

//   URL.revokeObjectURL(url);
// };


// function BillingHistoryList() {
//   const customActions = [
//     {
//       label: "Download Invoice",
//       icon: "download",   // material-symbols-outlined
//       color: "primary",
//       onClick: downloadInvoice,
//     },
//   ];

//   return (
//     <GenericTable
//       title="Revenue Details"
//       subtitle=""
//       columns={billingColumns}
//       rows={billingInfo.data.billing_history}
//       showView={false}
//       showEdit={false}
//       showDelete={false}
//       dropdownFilters={["client_name","store_name","brand"]}
//       // dateFilters={["due_date"]}
//       customActions={customActions}   // ✅ added
//       customActionsHeader="Download Invoice" // ✅ added
//     />
//   );
// }


// export default BillingHistoryList;



// import React from "react";
// import GenericTable from "../GenericTable/GenericTable";
// import billingInfo from "../../../data/billing_history_success.json";
 
// // Columns in required order
// const billingColumns = [
//   { id: "invoice_number", label: "Invoice Number" },
//   { id: "client_name", label: "Client Name" },
//   { id: "store_name", label: "Store Name" },
//   { id: "selected_plan", label: "Selected Plan" },
//   {
//     id: "total_amount",
//     label: "Total Amount ($)",
//     render: (row) => `$ ${Number(row.total_amount).toLocaleString()}`
//   },
//   { id: "due_date", label: "Due Date" },
//   { id: "payment_status", label: "Payment Status" }
// ];
 
// // Download function (unchanged)
// const downloadInvoice = (row) => {
//   const pdfContent = `
//     Invoice
//     ---------------------
//     Client: ${row.client_name}
//     Store: ${row.store_name}
//     Invoice #: ${row.invoice_number}
//     Plan: ${row.selected_plan}
//     Billing Date: ${row.billing_date}
//     Total Amount: ${row.total_amount}
//     Payment Status: ${row.payment_status}
//     Due Date: ${row.due_date}
//   `;
 
//   const blob = new Blob([pdfContent], { type: "application/pdf" });
//   const url = URL.createObjectURL(blob);
 
//   const link = document.createElement("a");
//   link.href = url;
//   link.download = `Invoice_${row.invoice_number}.pdf`;
//   link.click();
 
//   URL.revokeObjectURL(url);
// };
 
// // FORMAT DATA into required structure
// function BillingHistoryList() {
//   const formattedRows = billingInfo.data.billing_history.map((row) => ({
//     ...row,
//     selected_plan: row.subscription // plan + subscription will be added here later
//   }));
 
//   // custom action ONLY icon (same UI as before)
//   const customActions = [
//     {
//       label: "",
//       icon: "download",      // shows the small blue icon
//       color: "primary",
//       onClick: downloadInvoice
//     }
//   ];
 
//   return (
//     <GenericTable
//       title="Revenue"
//       columns={billingColumns}
//       rows={formattedRows}
 
//       showView={false}
//       showEdit={false}
//       showDelete={false}
 
//       searchEnabled={true}
 
//       dropdownFilters={["client_name", "payment_status"]}
//       dateFilters={["due_date"]}
 
//       customActions={customActions}
//       customActionsHeader="Download Invoice"
//     />
//   );
// }
 
// export default BillingHistoryList;
 

import React, { useCallback, useEffect, useState } from "react";
import GenericTable from "../GenericTable/GenericTable";
import config from "../../../config";
import axios from "axios";
import { Box, CircularProgress, TextField, Button, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, RadioGroup, FormControlLabel, Radio } from "@mui/material";

const billingColumns = [
  { id: "invoice_number", label: "Invoice Number", render: (row) => row.invoice_number || "N/A" },
  { id: "organization_name", label: "Client Name", render: (row) => row.organization_name || "N/A" },
  { id: "store_name", label: "Store Name", render: (row) => row.store_name || "N/A" },
  { id: "plan_name", label: "Selected Plan", render: (row) => row.plan_name || "N/A" },
  {
    id: "amount_cents",
    label: "Total Amount (₹)",
    render: (row) =>
      row.amount_cents
        ? `$${(row.amount_cents / 100).toLocaleString()}`
        : "N/A",
  },
  {
    id: "status",
    label: "Payment Status",
    render: (row) => row.status || "N/A",
  },
  {
    id: "invoice_due_date",
    label: "Due Date",
    render: (row) =>
      row.invoice_due_date
        ? new Date(row.invoice_due_date).toLocaleDateString()
        : "N/A",
  },
];

const downloadInvoice = async (row) => {
  try {
    // ✅ Get the invoice_id from the row
    const invoiceId = row.invoice_id;

    if (!invoiceId) {
      alert("Invoice ID not found");
      return;
    }

    // ✅ Call backend to get signed URL
    const response = await axios.get(
      `${config.API_BASE_URL_V1}/admin/invoices/${invoiceId}/download-url`
    );

    if (!response.data.success) {
      alert("Failed to generate download URL");
      return;
    }

    const downloadUrl = response.data.data.download_url;
    const invoiceNumber = response.data.data.invoice_number || row.invoice_number || "invoice";

    // ✅ Download the PDF from the signed URL
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `Invoice_${invoiceNumber}.pdf`;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Download error:", error);
    alert("Failed to download invoice. Please try again.");
  }
};

// ✅ Fallback: Direct download if invoice_pdf_url is available in row
const downloadInvoiceDirectly = (row) => {
  try {
    const pdfUrl = row.invoice_pdf_url;
    const invoiceNumber = row.invoice_number || "invoice";

    if (!pdfUrl) {
      alert("Invoice PDF URL not available");
      return;
    }

    // ✅ Open in new tab (browser will handle download)
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = `Invoice_${invoiceNumber}.pdf`;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Download error:", error);
    alert("Failed to download invoice. Please try again.");
  }
};

function BillingHistoryList() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // ✅ FILTER STATES
  const [search, setSearch] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedStore, setSelectedStore] = useState("");

  // ✅ DROPDOWN OPTIONS
  const [clients, setClients] = useState([]);
  const [stores, setStores] = useState([]);
  const [dropdownLoading, setDropdownLoading] = useState(false);

  // ✅ EXPORT STATES
  const [exportOpen, setExportOpen] = useState(false);
  const [exportType, setExportType] = useState("csv");

  // ✅ FETCH FILTER OPTIONS (Clients & Stores) - Only once on mount
  useEffect(() => {
    const fetchFilterOptions = async () => {
      setDropdownLoading(true);
      try {
        const res = await axios.get(
          `${config.API_BASE_URL_V1}/admin/revenue/filter-options`
        );
        if (res.data.success) {
          setClients(res.data.data.clients || []);
          setStores(res.data.data.stores || []);
        }
      } catch (error) {
        console.error("Error fetching filter options:", error);
      }
      setDropdownLoading(false);
    };
    fetchFilterOptions();
  }, []);

  // ✅ UNIVERSAL FETCH: Server-side pagination with filters
  const fetchBilling = useCallback(async (pageNum = page, rowSize = rowsPerPage, filters = {}) => {
    setLoading(true);
    try {
      const queryParams = {
        page: pageNum,
        page_size: rowSize,
        search: filters.search !== undefined ? filters.search : search,
        client_id: filters.client_id !== undefined ? filters.client_id : selectedClient,
        store_id: filters.store_id !== undefined ? filters.store_id : selectedStore,
      };

      // Remove undefined/empty values
      Object.keys(queryParams).forEach(
        (key) => !queryParams[key] && delete queryParams[key]
      );

      const res = await axios.get(
        `${config.API_BASE_URL_V1}/admin/revenue`,
        { params: queryParams }
      );

      setRows(res.data.data);
      setTotalCount(res.data?.pagination?.total_records || 0);
    } catch (error) {
      console.error("API Error:", error);
      setRows([]);
    }
    setLoading(false);
  }, [page, rowsPerPage, search, selectedClient, selectedStore]);

  // ✅ AUTO-FETCH: When page or rowsPerPage changes (keeps current filters)
  useEffect(() => {
    fetchBilling(page, rowsPerPage, {
      search: search,
      client_id: selectedClient,
      store_id: selectedStore,
    });
  }, [page, rowsPerPage]);

  // ✅ HANDLE SEARCH: Reset to page 1 and fetch with filters
  const handleSearch = () => {
    setPage(1);
    fetchBilling(1, rowsPerPage, {
      search: search,
      client_id: selectedClient,
      store_id: selectedStore,
    });
  };

  // ✅ CLEAR FILTERS: Reset all and fetch fresh
  const handleClearFilters = () => {
    setSearch("");
    setSelectedClient("");
    setSelectedStore("");
    setPage(1);
    fetchBilling(1, rowsPerPage, {
      search: "",
      client_id: "",
      store_id: "",
    });
  };

  // ✅ EXPORT: Get ALL filtered results (ignores pagination)
  const handleExportData = async () => {
    try {
      setLoading(true);
      let allData = [];
      let currentPage = 1;
      let hasMore = true;

      // ✅ Fetch ALL pages until no more data
      while (hasMore) {
        const res = await axios.get(`${config.API_BASE_URL_V1}/admin/revenue`, {
          params: {
            page: currentPage,
            page_size: 100, // Backend max limit is 100
            search: search || undefined,
            client_id: selectedClient || undefined,
            store_id: selectedStore || undefined,
          },
        });

        const pageData = res.data?.data || [];
        const totalRecords = res.data?.pagination?.total_records || 0;

        if (pageData.length === 0) {
          hasMore = false;
        } else {
          allData = [...allData, ...pageData];
          currentPage++;
        }
      }

      if (!allData.length) {
        setLoading(false);
        return alert("No data found!");
      }

      if (exportType === "csv") {
        const headers = Object.keys(allData[0]);
        const csvRows = [headers.join(",")];

        allData.forEach((row) => {
          csvRows.push(headers.map((h) => JSON.stringify(row[h] ?? "N/A")).join(","));
        });

        const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `billing_history_export_${new Date().toISOString()}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
      setExportOpen(false);
      setLoading(false);
    } catch (error) {
      console.error("Export Error:", error);
      alert("Failed to export data");
      setLoading(false);
    }
  };

  const customActions = [
    {
      label: "Download Invoice",
      icon: "download",
      color: "primary",
      onClick: (row) => {
        // ✅ Try backend endpoint first, fallback to direct download
        downloadInvoice(row).catch(() => downloadInvoiceDirectly(row));
      },
    },
  ];

  return (
    <div>
      {/* ✅ FILTER BAR - WHITE BACKGROUND */}
      <Box sx={{ mb: 0, p: 2, backgroundColor: "#ffffff", borderRadius: "8px 8px 0 0", display: "flex", gap: 2, flexWrap: "wrap", alignItems: "center", border: "1px solid #e0e0e0", borderBottom: "none" }}>
        <TextField
          label="Search Invoice Number"
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search invoice..."
          sx={{ minWidth: 200 }}
        />

        <TextField
          select
          label="Client Name"
          size="small"
          value={selectedClient}
          onChange={(e) => setSelectedClient(e.target.value)}
          sx={{ minWidth: 200 }}
          disabled={dropdownLoading}
        >
          <MenuItem value="">-- Select Client --</MenuItem>
          {clients.map((client) => (
            <MenuItem key={client.id} value={client.id}>
              {client.name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          label="Store Name"
          size="small"
          value={selectedStore}
          onChange={(e) => setSelectedStore(e.target.value)}
          sx={{ minWidth: 200 }}
          disabled={dropdownLoading}
        >
          <MenuItem value="">-- Select Store --</MenuItem>
          {stores.map((store) => (
            <MenuItem key={store.id} value={store.id}>
              {store.name}
            </MenuItem>
          ))}
        </TextField>

        <Button
          variant="contained"
          onClick={handleSearch}
          sx={{ height: "40px", backgroundColor: "#1976d2", color: "#fff", "&:hover": { backgroundColor: "#1565c0" } }}
        >
          Search
        </Button>

        <Button
          variant="outlined"
          onClick={handleClearFilters}
          sx={{ height: "40px", borderColor: "#1976d2", color: "#1976d2", "&:hover": { backgroundColor: "#f5f5f5" } }}
        >
          Clear Filters
        </Button>

        <Button
          variant="contained"
          onClick={() => setExportOpen(true)}
          sx={{ height: "40px", backgroundColor: "#1976d2", color: "#fff", "&:hover": { backgroundColor: "#1565c0" } }}
        >
          Export
        </Button>
      </Box>

      {/* ✅ EXPORT DIALOG */}
      <Dialog open={exportOpen} onClose={() => setExportOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle textAlign="center">Export Data</DialogTitle>
        <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1, pb: 2 }}>
          <RadioGroup value={exportType} onChange={(e) => setExportType(e.target.value)}>
            <FormControlLabel value="csv" control={<Radio />} label="CSV" />
          </RadioGroup>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 2 }}>
          <Button variant="outlined" onClick={() => setExportOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleExportData} autoFocus>Download</Button>
        </DialogActions>
      </Dialog>

      {/* ✅ LOADER - Show while data is loading */}
      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
          <CircularProgress />
        </Box>
      )}

      {/* ✅ TABLE WITH SERVER-SIDE PAGINATION */}
      {!loading && (
        <GenericTable
          title="" // ✅ REMOVED: Revenue Details heading
          columns={billingColumns}
          rows={rows}
          showView={false}
          showEdit={false}
          showDelete={false}
          hideExport={true} // ✅ Hide export button - using custom export in filter bar
          isServerSide={true}
          currentPage={page - 1}
          rowsPerPage={rowsPerPage}
          totalCount={totalCount}
          onPageChange={(_, newPage) => {
            setPage(newPage + 1);
          }}
          onRowsPerPageChange={(event) => {
            const newRowsPerPage = parseInt(event.target.value, 10);
            setRowsPerPage(newRowsPerPage);
            setPage(1);
          }}
          customActions={customActions}
          customActionsHeader="Download Invoice"
        />
      )}
    </div>
  );
}

export default BillingHistoryList;
 